import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function UkFerryPort(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 14"
  }, props), React.createElement("path", {
    d: "M6.006 1.167c.315 0 .57.261.57.583a.577.577 0 01-.57.583.577.577 0 01-.57-.583c0-.322.256-.583.57-.583m5.677 8.22l-2.685.305c-.238.027-.34.323-.17.496l.594.608a4.737 4.737 0 01-2.56 1.369V5.833h1.425c.316 0 .57-.26.57-.583a.576.576 0 00-.57-.583H6.862v-1.41c.508-.304.855-.862.855-1.507C7.717.785 6.95 0 6.007 0c-.944 0-1.712.785-1.712 1.75 0 .645.347 1.203.856 1.507v1.41H3.725c-.315 0-.57.26-.57.583 0 .323.255.583.57.583h1.426v6.332a4.737 4.737 0 01-2.567-1.376l.588-.6c.169-.174.067-.47-.17-.497L.317 9.387a.288.288 0 00-.315.322L.3 12.456a.283.283 0 00.485.174l.59-.604A6.41 6.41 0 006.007 14a6.411 6.411 0 004.625-1.968l.584.598c.17.173.459.07.485-.174l.298-2.747a.289.289 0 00-.315-.322"
  }));
}

export { UkFerryPort };
//# sourceMappingURL=UkFerryPort.js.map